import type { TomorrowAlert } from '@pelvia/shared/hooks/patient/usePainPatterns'

/**
 * Heads-up banner when tomorrow's pain is predicted high — surfaces the score,
 * the contributing risk factors, and any as-needed meds. Renders nothing
 * unless the prediction is flagged to show.
 */
export default function TomorrowAlertCard({ alert }: { alert?: TomorrowAlert | null }) {
  if (!alert?.show) return null

  return (
    <section className="card pp-alert">
      <div className="pp-alert-badge">
        <span className="pp-alert-dot" /> Heads up for tomorrow
      </div>
      <div className="pp-alert-title">
        Predicted pain: <em>{alert.predicted_score}/10</em>
      </div>
      {alert.risk_factors.length > 0 && (
        <ul className="pp-alert-body">
          {alert.risk_factors.map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ul>
      )}
      {alert.prn_medications.length > 0 && (
        <div className="pp-alert-actions">
          Consider your as-needed meds:{' '}
          {alert.prn_medications.map((m) => m.name).join(', ')}
        </div>
      )}
    </section>
  )
}
